<template>
    <div class="content-center none-click">
      <div class="banner">
        <div class="banner_box">
            <div class="banner_title">千橙ERP</div>
            <div class="banner_line"></div>
            <div class="banner_title2">面向中小微实体零售门店，帮助门店提效降本增收拓客</div>
            <!-- <div class="banner_text">企业私域电商直播平台</div> -->
        </div>
        <img src="@/assets/Mobile/images/QcLiveBroadcast/banner.png" alt="">
      </div>
      <div class="programme programme2">
        <div class="sk-mobile-title">
          <div class="title">门店经营痛点</div>
        </div>
        <div class="content" style="margin-top: 10px;">
            <img src="@/assets/Mobile/images/QcErpSystem/programme1.png" alt="">
        </div>
      </div>
      <div class="programme">
        <div class="sk-mobile-title">
          <div class="title">优选供应链渠道，商品一键入库</div>
          <div class="sub-title">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div>
        </div>
        <div class="content" style="margin-top: 25px;">
            <img src="@/assets/Mobile/images/QcErpSystem/programme2.png" alt="">
        </div>
      </div>
      <div class="programme programme3">
        <div class="sk-mobile-title">
          <div class="title">多类型商品管理，业务高效流转</div>
          <div class="sub-title">多种商品建档方式，且支持多种类型商品管理，帮助店铺高效管理商品资产</div>
        </div>
        <div class="content" style="margin-top: 17px;">
            <img src="@/assets/Mobile/images/QcErpSystem/programme3.png" alt="">
        </div>
      </div>
      <div class="programme programme1">
        <div class="sk-mobile-title">
          <div class="title">全渠道订单聚合管理，多端协同</div>
          <div class="sub-title">全渠道订单协同管理，数据云端化，助力经营提效</div>
        </div>
        <div class="content" style="margin-top: 15px;">
            <img src="@/assets/Mobile/images/QcErpSystem/programme4.png" alt="">
        </div>
      </div>
      <div class="programme programme3">
        <div class="sk-mobile-title">
          <div class="title">报表分析，帮助店铺开源节流</div>
          <div class="sub-title">多维业务分析报表与财务报表，深度分析经营状况，辅助制定经营策略</div>
        </div>
        <div class="content" style="margin-top: 17px;">
            <img src="@/assets/Mobile/images/QcErpSystem/programme5.png" alt="">
        </div>
      </div>
      <div class="programme programme1">
        <div class="sk-mobile-title">
          <div class="title">更多场景功能</div>
          <div class="sub-title">功能齐全，覆盖店铺经营全场景，为店铺降本增效保驾护航</div>
        </div>
        <div class="content" style="margin-top: 15px;">
            <img src="@/assets/Mobile/images/QcErpSystem/programme6.png" alt="">
        </div>
      </div>
      <div class="programme programme3">
        <div class="sk-mobile-title">
          <div class="title">不同客群差异化服务</div>
          <!-- <div class="sub-title">多维业务分析报表与财务报表，深度分析经营状况，辅助制定经营策略</div> -->
        </div>
        <div class="content" style="margin-top: 17px;">
            <img src="@/assets/Mobile/images/QcErpSystem/programme7.png" alt="">
            <img style="margin-top: 3px;" src="@/assets/Mobile/images/QcErpSystem/programme8.png" alt="">
        </div>
      </div>
      <div class="programme" style="background:rgba(234,243,255,.67)">
        <div class="sk-mobile-title">
          <div class="title">客户案例</div>
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcErpSystem/case1.png" alt="">
            <img src="@/assets/Mobile/images/QcErpSystem/case2.png" alt="">
        </div>
      </div>
      <Case title="微商城" />
      <ContactForm info-sources="千橙ERP" />
      <TryModal v-if="tryVisible" :visible="tryVisible" info-sources="千橙ERP" @cancel="modalClose" />
  
    </div>
  </template>
  
  <script>
  import metaInfo from '@/common/util/metaInfo'
  import ContactForm from '@/Mobile/Mobilecom/ContactForm'
  import Case from '@/Mobile/Mobilecom/Case'
  import TryModal from '@/Mobile/Mobilecom/TryModal'
  
  export default {
    metaInfo: metaInfo.QcErpSystem,
    components: {
      ContactForm,
      Case,
      TryModal
    },
    data() {
      return {
        tryVisible: false,
        tooItem:'1',
      }
    },
    mounted() {
  
    },
    methods: {
      linkTo(path) {
          this.$router.push({ path: '/m/' + path })
          this.$nextTick(() => {
              this.open = false
          })
      },
      checkBg(item) {
        this.tooItem = item;
      },
      openModal: function() {
        this.tryVisible = true
      },
      modalClose: function(data) {
        this.tryVisible = data
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .programme1{
    background: #FFFFFF;
  }
  .programme2{
    background: #F8FCFF;
  }
  .programme3{
    background: #F8FBFF;
  }
  .banner_box{
    position: absolute;
    top: 25px;
    left:16px;
    .banner_title{
        height: 25px;
        font-size: 18px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 25px;
        text-align: left;
    }
    .banner_title2{
        width: 142px;
        height: 28px;
        font-size: 10px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 14px;
        margin-top: 22px;
        text-align: left
    }
    .banner_line{
        width: 50px;
        height: 3px;
        background: #28DAFB;
        margin-top:6px;
        
    }
    .banner_text{
        margin-top:22px;
        width: 134px;
        height: 78px;
        font-size: 10px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 17px;
        text-align: left
    }
  }
  .banner {
    width: 100%;
    height: 200px;
    margin-top: 50px;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
 
  </style>
  